import { Mongo } from 'meteor/mongo';

export * from './payment-policy.mjs';

export const ProviderConfigsCollection = new Mongo.Collection('providerConfigs');
export const PaymentAttemptsCollection = new Mongo.Collection('paymentAttempts');
export const PaymentAttemptItemsCollection = new Mongo.Collection('paymentAttemptItems');
export const PaymentProviderRecordsCollection = new Mongo.Collection('paymentProviderRecords');
export const PaymentProviderEventsCollection = new Mongo.Collection('paymentProviderEvents');
export const PaymentEventsCollection = new Mongo.Collection('paymentEvents');
export const PaymentRiskObservationsCollection = new Mongo.Collection('paymentRiskObservations');
export const PaymentOperationsSummariesCollection = new Mongo.Collection('paymentOperationsSummaries');
export const PaymentRecipientsCollection = new Mongo.Collection('paymentRecipients');
export const PaymentSettlementsCollection = new Mongo.Collection('paymentSettlements');
export const PaymentQuotePoliciesCollection = new Mongo.Collection('paymentQuotePolicies');
